module.exports = "data:audio/mpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9taW5kZnVsbmVzcy1hZHVsdC1icmllZi5tcDMiOw=="